<template>
    <div>

        <TextBanner>
        Bei der geplanten Besiedelung des Mondes spielt der <b>Shackleton-Krater am Südpol</b> eine zentrale Rolle. Er ist so tief, dass in sein Inneres kein Sonnenlicht fällt. 
        Forschende vermuten dort Wasser in Form von Eis. In der Nähe des Kraters könnte die <b>Basisstation</b> entstehen. 
        </TextBanner>

        <InfoBox modalName="IB_Basis">
            <template #title>Die Basisstation auf der Mondoberfläche</template>
            <template #subline></template>
            <template>
                <p>Mit Hilfe von Solarmodulen wird Energie gewonnen, um die Basisstation auf dem Mond zu betreiben. Eis in tiefen Mondkratern wäre eine Voraussetzung, um z.B. Treibstoff (Wasserstoff) zu produzieren. 
                    Mit diesem Zwischenschritt rückt das Reiseziel Mars für die Menschheit ein gutes Stück näher.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/050_basis.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="500" data-height="500" v-lazy="require('../assets/img/050_basis_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Esa - P. Carril</div>
                            So könnten Teile der Basisstation auf der Mondoberfläche aussehen.
                        </figcaption>
                    </figure>
                </FullscreenImage>

            </template>
        </InfoBox>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('TolleInfoBox')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                radiusLimits: [1,100],
                position: [.4,3,2.2],   //0,3,2
                target: [-12.7,-7,-.7],
                animationSpeed: 900,
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.01,  //0.01
            },
            
            artemis_geo: {
                scaling: [0.05,0.05,-0.05],
                Mars:{
                    visible: false
                },

                Erde_Plane:{
                    fade:true,
                    visible: true,
                    scaling:[.5,.5,.5]
                },

                Sonne: {
                    fade: true,
                    visible: true
                    },

                Mond:{
                    pickable: false,
                },

                Weltall:{
                    visible:true
                },

                Label_Shackleton:{
                    visible: true,
                    renderingGroupId: 2,
                    billboardMode: 7,
                    Text_Shackleton:{
                        renderingGroupId:2
                    },
                },

                Marker_Suedpol:{
                    visible: true
                },

                Station_All:{
                    Empty:{
                        Orion:{
                            Label_Orion:{
                                fade: false,
                                visible: false,
                                billboardMode: 7,
                                }
                            }
                        }
                    },
            },
            

            hotspots: {
                info_11: {
                    visible: true,
                    infoBox: 'IB_Basis',
                    position: [-12.5, -6.6, -.7],   //-12.5, -6.5, .7],
                    renderingGroupId: 1,
                    scale:.4,
                }
            },
           
        },
        babylonReady: function () {

        this.$babylonController.timer.add(5400, () => {
            this.$babylonController.camera.setBetaLimits(1.7,3.14);
        });

        this.$babylonController.timer.add(5400, () => {
            this.$babylonController.setCameraRadiusLimit(2,150);
        });

        // this.$babylonController.timer.add(4500, () => {
        //     this.$babylonController.setRotationLimit(Math.PI / 2);
        // });

        this.$babylonController.goToAnimation("anim_power", 0);
        this.$babylonController.goToAnimation("anim_lander", 0);
        this.$babylonController.goToAnimation("anim_canadarm", 0);
        this.$babylonController.goToAnimation("anim_logistics", 0);
        this.$babylonController.goToAnimation("anim_habitation", 0);
        this.$babylonController.goToAnimation("anim_orion", 0);
        this.$babylonController.goToAnimation("anim_esprit", 0);
        this.$babylonController.goToAnimation("anim_halo", 0);
        this.$babylonController.goToAnimation("anim_airlock", 0);

        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
